import axios from "axios";

import type { UserFeedbackApiResponse } from "../shared/interface/UserFeedback.interface";
import { ParamsObject } from "../shared/interface/parking.interface";

export const getAllFeedback = async (params: ParamsObject) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/user-feedback/list?page=${params.page}&pageSize=${params.pageSize}`;

    if (params.customerId) {
      query += `&customerId=${params.customerId}`;
    }

    if (params.locationId) {
      query += `&locationId=${params.locationId}`;
    }

    if (params.searchQuery) {
      query += `&searchQuery=${params.searchQuery}`;
    }

    const response = await axios.get(query);
    return response.data as UserFeedbackApiResponse;
  } catch (error) {
    throw error;
  }
};
